import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzUploadModule } from 'ng-zorro-antd/upload';

import { NzCommentModule } from 'ng-zorro-antd/comment';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzTableModule } from 'ng-zorro-antd/table';

import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzTagModule } from 'ng-zorro-antd/tag';

import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzTreeViewModule } from 'ng-zorro-antd/tree-view';



@NgModule({
  declarations: [],
  exports: [
    NzLayoutModule,
        NzMenuModule,
        NzButtonModule,
        NzSliderModule,
        NzBreadCrumbModule,
        NzCollapseModule,
        NzFormModule,
        NzStepsModule,
        NzCardModule,
        NzInputModule,
        NzSelectModule,
        NzSwitchModule,
        NzUploadModule,
        NzTabsModule,
        NzSegmentedModule,
        NzModalModule,
        NzListModule,
        NzIconModule,
        NzTreeModule,
        NzDatePickerModule,
        NzResultModule,
        ReactiveFormsModule,
        NzTypographyModule,
        NzAvatarModule,
        NzDividerModule,
        NzTimelineModule,
        NzGridModule,
        NzDropDownModule,
        NzTableModule,
        NzCommentModule,
        NzSpaceModule,
        NzImageModule,
        NzDrawerModule,
        NzStatisticModule,
        NzPageHeaderModule,
        NzDescriptionsModule,        
        NzToolTipModule,
        NzSpinModule,
        NzAlertModule,
        NzPopconfirmModule,
        NzBadgeModule,
        NzProgressModule,
        NzCarouselModule,
        NzCheckboxModule,
        NzTagModule,
        NzSegmentedModule,
        NzPaginationModule,
        NzTreeViewModule,
        NzDatePickerModule ,
        
  ],
  imports: [
    CommonModule
  ],

})
export class NgZorroModule { }
